<!-- =========================================================================================
  File Name: Store.vue
  Description: Store Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card class="mb-2" v-if="loaded">

      <div slot="no-body" class="tabs-container pl-6 py-3">
        <div class="w-full vx-row mb-2">
          <div class="vx-col w-3/12">
            <ejs-textbox floatLabelType="Auto" placeholder="Código" :enabled="editing" v-model="data_local.code"/>
          </div>
          <div class="flex vx-col w-9/12 items-center justify-end h-full">
            <div class="flex items-center justify-center w-48 h-12 mr-px rounded-sm bg-primary text-white cursor-pointer" @click="save" v-if="editing">
              <vs-icon icon-pack="feather" icon="icon-save" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Guardar cambios</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 rounded-sm border border-solid border-warning cursor-pointer" @click="reset_data" v-if="editing">
              <vs-icon icon-pack="feather" icon="icon-corner-up-left" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Cancelar</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 mr-px rounded-sm bg-primary text-white cursor-pointer" @click="editing = true" v-if="!editing">
              <vs-icon icon-pack="feather" icon="icon-edit-2" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Editar</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 rounded-sm bg-danger text-white cursor-pointer" @click="confirmDeleteRecord" v-if="!editing">
              <vs-icon icon-pack="feather" icon="icon-x" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Eliminar</div>
            </div>
          </div>
        </div>
        <div class="w-full vx-row">
          <div class="vx-col w-full">
            <ejs-textbox floatLabelType="Auto" placeholder="Nombre" :enabled="editing" v-model="data_local.name"/>
          </div>
        </div>
        <vs-tabs>
          <vs-tab label="Datos de servicio">
            <div class="w-full vx-row">
              <div class="vx-col w-1/3">
                <ejs-textbox floatLabelType="Auto" placeholder="Hora de apertura" :enabled="editing" v-model="data_local.carryOutOpenHour"/>
              </div>
              <div class="vx-col w-1/3">
                <ejs-textbox floatLabelType="Auto" placeholder="Hora de cierre" :enabled="editing" v-model="data_local.carryOutCloseHour"/>
              </div>
            </div>
            <div class="w-full vx-row">
              <div class="vx-col w-1/3 my-3">
                <ejs-checkbox label='Ofrece servicio a domicilio' v-model="data_local.delivery" :checked="data_local.delivery" :disabled="!editing"/>
              </div>
              <div class="vx-col w-1/3">
                <ejs-textbox floatLabelType="Auto" placeholder="Hora de apertura domicilio" :enabled="editing" v-model="data_local.deliveryOpenHour"/>
              </div>
              <div class="vx-col w-1/3">
                <ejs-textbox floatLabelType="Auto" placeholder="Hora de cierre domicilio" :enabled="editing" v-model="data_local.deliveryCloseHour"/>
              </div>
            </div>
            <div class="w-full vx-row">
              <div class="vx-col w-1/3">
                <ejs-dropdownlist floatLabelType="Auto" placeholder="Estado" highlight=true :dataSource="status" :fields="{text: 'value', value: 'id'}" v-model="data_local.status" :enabled="editing"></ejs-dropdownlist>
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Conectividad">
            <div class="w-full vx-row">
              <div class="vx-col w-1/3">
                <ejs-textbox floatLabelType="Auto" placeholder="Dirección IP Servidor" :enabled="editing" v-model="data_local.ipAddress"/>
              </div>
              <div class="vx-col w-1/3">
                <ejs-textbox floatLabelType="Auto" placeholder="Puerto de acceso API" :enabled="editing" v-model="data_local.port"/>
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Ubicación">
            <div class="w-full vx-row">
              <div class="vx-col w-1/2">
                <ejs-dropdownlist floatLabelType="Auto" placeholder="Departamento" highlight=true :dataSource="states" :fields="{text: 'name', value: 'id'}" v-model="data_local.stateId" :enabled="editing"/>
              </div>
              <div class="vx-col w-1/2">
                <ejs-dropdownlist floatLabelType="Auto" placeholder="Municipio" highlight=true :dataSource="cities" :fields="{text: 'name', value: 'id'}" v-model="data_local.cityId" :enabled="editing"/>
              </div>
            </div>
            <div class="w-full vx-row">
              <div class="vx-col w-1/4">
                <ejs-numerictextbox floatLabelType="Auto" placeholder="Latitud" format="N10" :enabled="editing" textAlign='Right' v-model="data_local.latitude"/>
              </div>
              <div class="vx-col w-1/4">
                <ejs-numerictextbox floatLabelType="Auto" placeholder="Longitud" format="N10" :enabled="editing" textAlign='Right' v-model="data_local.longitude"/>
              </div>
            </div>
            <div class="w-full vx-row mt-4">
              <div class="vx-col w-full">
                <MapboxMap
                  ref="map"
                  class="flex w-full"
                  :center="center"
                  :zoom="zoom"
                  :markers="markers"
                  :perimeter="data_local.perimeter"
                  :draggable="editing"
                  @dragend="dragEnd"
                />
              </div>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>

    </vx-card>
  </div>
</template>

<script>
import Vue from "vue";
import states from '@/store/data/states.json';
import cities from '@/store/data/cities.json';
import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
import {NumericTextBoxPlugin} from "@syncfusion/ej2-vue-inputs";
import {CheckBoxPlugin} from "@syncfusion/ej2-vue-buttons";
import {DropDownListPlugin, MultiSelectPlugin} from "@syncfusion/ej2-vue-dropdowns";
import MapboxMap from '../../components/MapBoxMap';
import {firebase, db} from '@/firebaseConfig';

Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(MultiSelectPlugin);

export default {
  components: {
    MapboxMap
  },
  data() {
    return {
      loaded: false,
      activeTab: 0,
      editing: false,
      id: 0,
      data: null,
      status: [{id: 'ACT', value: 'Activa'}, {id: 'IN', value: 'Inactiva'}],
      imageChanged: false,
      data_local: {
        id: 0,
        code: '',
        name: '',
        address: '',
        carryOutCloseHour: '',
        carryOutOpenHour: '',
        deliveryCloseHour: '',
        deliveryOpenHour: '',
        cityId: '',
        cityName: '',
        delivery: false,
        ipAddress: '',
        port: '',
        latitude: 0,
        longitude: 0,
        stateId: '',
        stateName: '',
        status: '',
        statusName: '',
        stockId: '',
        parameters: []
      },
      id_not_found: false,
      currentStatus: 0,
      zoom: 14
    }
  },
  computed: {
    states() {
      return states.states;
    },
    cities() {
      if (this.data_local.stateId) {
        return cities.cities.filter(item => item.stateId == this.data_local.stateId);
      } else {
        return [];
      }
    },
    center() {
      let center = [-90.550351, 14.62134];
      if (this.data_local.latitude && this.data_local.latitude != 0) {
        center = [this.data_local.longitude, this.data_local.latitude];
      }
      return center;
    },
    markers() {
      const markers = [];
      if (this.data_local.latitude && this.data_local.latitude != 0) {
        markers.push({
          id: this.data_local.id,
          code: this.data_local.code,
          name: this.data_local.name,
          position: [this.data_local.longitude, this.data_local.latitude]});
      }
      return markers;
    }
  },
  methods: {
    reset_data() {
      if (this.id > 0) {
        this.data_local = {...this.data_local, ...JSON.parse(JSON.stringify(this.data))};
        this.editing = false;
        this.loaded = true;
      } else {
        this.$router.push({name: 'stores'});
      }
    },
    getData(id) {
      if (id) {
        if (id == 0) {
          this.$vs.loading.close();
          this.loaded = true;
          this.id_not_found = false;
          this.editing = true;
        } else if (this.$store.stores) {
          this.data = {...this.data_local, ...this.$store.getters.getStore(id)};
          this.reset_data();
        } else {
          const self = this;
          setTimeout(function () {
            self.data = {...self.data_local, ...self.$store.getters.getStore(id)};
            self.reset_data();
          }, 750);
        }
      } else {
        this.$vs.loading.close();
        this.loaded = true;
        if (id == 0) {
          this.id_not_found = false;
        }
        this.editing = true;
      }
    },
    dragEnd(args) {
      this.data_local.latitude = args.marker.getLngLat().lat;
      this.data_local.longitude = args.marker.getLngLat().lng;
    },
    validateForm() {
      let message = '';
      if (this.data_local.code.trim() == '') {
        message = `${message}${(message == '' ? '' : '<br/>')}Debe indicar un código`;
        // message += (message == '' ? '' : '<br/>') + 'Debe indicar un código';
      }
      if (this.data_local.name.trim() == '') {
        message = `${message}${(message == '' ? '' : '<br/>')}Debe indicar una descripción`;
      }
      if (this.data_local.status.trim() == '') {
        message = `${message}${(message == '' ? '' : '<br/>')}Debe seleccionar una estado`
      }
      if (message != '') {
        this.$vs.notify({
          title: 'Error validando información',
          text: message,
          color: 'danger'
        });
      }
      return (message == '');
    },
    updateList(list, newId) {
      const self = this;
      db.collection('catalogs').doc('stores').update({list: list})
        .then(() => {
          self.$vs.notify({
            title: 'Información actualizada',
            text: 'Datos de la tienda fueron actualizados correctamente',
            color: 'primary'
          });
          if (self.id == 0) {
            self.$router.push({name: 'store', params: {id: newId}});
          }
          self.editing = false;
          self.$vs.loading.close();
        })
        .catch((error) => {
          self.$vs.notify({
            title: 'Error al actualizar',
            text: error.message,
            color: 'danger'
          });
          self.$vs.loading.close();
        })
    },
    save() {
      if (this.validateForm()) {
        this.$vs.loading({
          text: 'Guardando información de tienda',
          type: 'point'
        });
        this.data_local.statusName = this.data_local.status == 'ACT' ? 'Activa' : 'Inactiva';
        const list = [...this.$store.getters.storesList];
        if (this.data_local.id > 0) {
          const index = list.findIndex(i => i.id === this.data_local.id);
          if (index >= 0) {
            list[index] = JSON.parse(JSON.stringify(this.data_local));
            this.updateList(list, this.data_local.id);
          }
        } else {
          const self = this;
          db.collection('catalogs').doc('stores').update({sequence: firebase.firestore.FieldValue.increment(1)})
            .then(() => {
              const data = {...self.data_local};
              db.collection('catalogs').doc('stores').get()
                .then(doc => {
                  if (doc.exists) {
                    const newId = doc.data();
                    data.id = newId.sequence;
                    list.push(data);
                    self.updateList(list, data.id);
                  }
                })
            });
        }
      }
    },
    confirmDeleteRecord() {
      console.log('Delete');
    }
  },

  mounted() {
    this.id = parseInt(this.$route.params.id);
    const self = this;
    setTimeout(function () {
      self.getData(self.id);
    }, 750);
  }
}
</script>

<style lang="scss">
@import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
/*@import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';*/
@import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-lists/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
/*@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";*/
@import "../../../../node_modules/@syncfusion/ej2-vue-richtexteditor/styles/material.css";
</style>
